const fonts = {
  roboto: "Roboto",
};

export default fonts;
